// Sistem servisinden gelen metinler, Windows-1254 (Latin-5) baytlarinin
// Windows-1252 / ISO-8859-1 olarak cozulmesi yuzunden bozuk gelebiliyor.
// Bu bozulmada Turkce karakterler her zaman ayni alti karaktere donusuyor:
//   Ğ -> Ð   İ -> Ý   Ş -> Þ   ğ -> ð   ı -> ý   ş -> þ
// (ç, ö, ü iki kod sayfasinda da ayni oldugu icin etkilenmiyor.)
// Asagidaki eslestirme bu donusumu geri alir. Eslesen alti karakter Turkce
// metinlerde kullanilmadigi icin donusum guvenlidir.
const LATIN5_MOJIBAKE = {
  "\u00D0": "\u011E", // Ð -> Ğ
  "\u00DD": "\u0130", // Ý -> İ
  "\u00DE": "\u015E", // Þ -> Ş
  "\u00F0": "\u011F", // ð -> ğ
  "\u00FD": "\u0131", // ý -> ı
  "\u00FE": "\u015F", // þ -> ş
};

const MOJIBAKE_REGEX = /[\u00D0\u00DD\u00DE\u00F0\u00FD\u00FE]/g;

// Tek bir metindeki bozuk Turkce karakterleri duzeltir.
export function fixTurkishChars(text) {
  if (typeof text !== "string") return text;
  return text.replace(MOJIBAKE_REGEX, (char) => LATIN5_MOJIBAKE[char]);
}

// Servisten gelen JSON'un icindeki tum metinleri duzeltir.
// Dizi/nesne icinde ne kadar derine inerse insin tum string degerleri gezer.
export function fixTurkishCharsDeep(value) {
  if (typeof value === "string") return fixTurkishChars(value);
  if (Array.isArray(value)) return value.map(fixTurkishCharsDeep);
  if (value && typeof value === "object") {
    Object.keys(value).forEach((key) => {
      value[key] = fixTurkishCharsDeep(value[key]);
    });
    return value;
  }
  return value;
}
